
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manual/create_match",
      function () {
        return require("private-next-pages/manual/create_match.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manual/create_match"])
      });
    }
  